import { useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";

const TAP_WINDOW_MS = 900;
const TAP_COUNT = 3;

/**
 * Triple-click within a short window opens /admin (no visible admin link).
 */
export function useAdminShortcut() {
  const navigate = useNavigate();
  const taps = useRef({ count: 0, lastAt: 0 });

  return useCallback(() => {
    const now = Date.now();
    if (now - taps.current.lastAt > TAP_WINDOW_MS) {
      taps.current.count = 0;
    }
    taps.current.lastAt = now;
    taps.current.count += 1;
    if (taps.current.count >= TAP_COUNT) {
      taps.current.count = 0;
      navigate("/admin");
    }
  }, [navigate]);
}
